import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "m1",
    title: "星际远征：破晓",
    type: "电影",
    region: "美国",
    year: 2025,
    score: 9.1,
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%2C%20deep%20space%20nebula%20backdrop%2C%20teal%20and%20orange%20rim%20lighting%2C%20epic%20scale%2C%20film%20grain%2C%20high%20contrast%20dramatic%20artwork&width=600&height=900&seq=cherry-mv-01&orientation=portrait",
    description:
      "人类最后的远航舰队驶向未知星系，一场跨越光年的救援任务，将一群宇航员的命运推向宇宙的尽头。",
    director: "克里斯·诺兰",
    actors: ["利亚姆·福特", "艾拉·诺伊", "乔纳森·里德"],
    tags: ["科幻", "太空", "冒险", "史诗"],
    updateTime: "2026-09-28",
    status: "已完结",
    views: 4820,
    featured: true,
  },
  {
    id: "m2",
    title: "暗河猎人",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    score: 8.4,
    cover:
      "https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20of%20a%20silhouetted%20detective%20walking%20along%20a%20rainy%20canal%20at%20night%2C%20reflective%20wet%20streets%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20smoke%20and%20fog%2C%20cinematic%20noir%20atmosphere%2C%20high%20contrast&width=600&height=900&seq=cherry-mv-02&orientation=portrait",
    description:
      "一桩沉寂十年的悬案重新浮出水面，沉默寡言的刑警循着城市暗河，追查真相与被掩埋的往事。",
    director: "陈墨",
    actors: ["张启明", "李泽宇", "王雪"],
    tags: ["犯罪", "悬疑", "警匪", "剧情"],
    updateTime: "2026-09-26",
    status: "已上映",
    views: 3610,
    featured: true,
  },
  {
    id: "m3",
    title: "长安夜行录",
    type: "电影",
    region: "中国大陆",
    year: 2023,
    score: 8.7,
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20historical%20movie%20poster%20of%20a%20lantern%20lit%20city%20street%20at%20night%2C%20traditional%20architecture%20and%20red%20lanterns%2C%20elegant%20warrior%20figure%20in%20flowing%20robes%2C%20warm%20gold%20and%20deep%20crimson%20palette%2C%20ink%20painting%20texture%2C%20cinematic&width=600&height=900&seq=cherry-mv-03&orientation=portrait",
    description:
      "大唐长安的最后一个夜晚，一名女捕快与神秘刺客被迫联手，揭开一场关乎天下安危的惊天阴谋。",
    director: "顾清和",
    actors: ["林婉", "萧逸", "赵怀民"],
    tags: ["古装", "动作", "悬疑", "历史"],
    updateTime: "2026-09-24",
    status: "已上映",
    views: 5290,
    featured: true,
  },
  {
    id: "m4",
    title: "风起云涌",
    type: "电影",
    region: "中国香港",
    year: 2024,
    score: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20poster%20of%20a%20sport%20car%20drifting%20through%20neon%20lit%20harbor%20city%20streets%2C%20flying%20sparks%20and%20motion%20blur%2C%20orange%20and%20black%20tones%2C%20explosive%20energy%2C%20dramatic%20low%20angle%2C%20cinematic%20poster&width=600&height=900&seq=cherry-mv-04&orientation=portrait",
    description:
      "当卧底、黑帮与国际追兵同时涌入同一座港口城市，一场速度与火力的对决就此点燃。",
    director: "麦浩东",
    actors: ["陈子豪", "吴君豪", "林薇"],
    tags: ["动作", "警匪", "飙车", "港片"],
    updateTime: "2026-09-22",
    status: "已上映",
    views: 2980,
  },
  {
    id: "m5",
    title: "时光信笺",
    type: "电影",
    region: "韩国",
    year: 2023,
    score: 8.2,
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20drama%20movie%20poster%20of%20a%20young%20couple%20under%20soft%20sunset%20light%20near%20a%20wooden%20mailbox%2C%20blurred%20warm%20bokeh%2C%20pastel%20peach%20and%20amber%20tones%2C%20gentle%20nostalgic%20mood%2C%20soft%20film%20aesthetic%2C%20heartfelt%20poster&width=600&height=900&seq=cherry-mv-05&orientation=portrait",
    description:
      "一封迟到了十五年的信，让两个早已走散的人重新面对当年的约定与未曾说出口的心意。",
    director: "朴敏书",
    actors: ["金秀雅", "李俊昊", "崔恩熙"],
    tags: ["爱情", "剧情", "治愈", "温情"],
    updateTime: "2026-09-20",
    status: "已上映",
    views: 2470,
  },
  {
    id: "m6",
    title: "追光者",
    type: "电影",
    region: "中国大陆",
    year: 2025,
    score: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=inspirational%20drama%20movie%20poster%20of%20a%20young%20photographer%20silhouetted%20against%20a%20vast%20golden%20field%20at%20dawn%2C%20sun%20rays%20and%20lens%20flare%2C%20warm%20amber%20and%20soft%20brown%20palette%2C%20minimalist%20composition%2C%20emotional%20and%20hopeful%20tone&width=600&height=900&seq=cherry-mv-06&orientation=portrait",
    description:
      "一个执拗的年轻人背起相机走遍山川，只为拍下那道传说中能治愈一切的光。",
    director: "周致远",
    actors: ["许安", "杨琳", "何澄"],
    tags: ["剧情", "励志", "家庭", "温情"],
    updateTime: "2026-09-18",
    status: "已上映",
    views: 1990,
  },
  {
    id: "t1",
    title: "都市浮生记",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    score: 8.6,
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20series%20poster%20of%20a%20group%20of%20young%20professionals%20on%20a%20rooftop%20overlooking%20a%20glowing%20city%20skyline%20at%20dusk%2C%20warm%20window%20lights%2C%20amber%20and%20deep%20charcoal%20tones%2C%20cinematic%20ensemble%20composition&width=600&height=900&seq=cherry-tv-01&orientation=portrait",
    description:
      "五个从未谋面的年轻人因一间合租公寓走到一起，在繁华都市里各自奔跑，也彼此照亮。",
    director: "沈亦",
    actors: ["孙可", "刘思远", "郑好", "王漫"],
    tags: ["都市", "情感", "群像", "职场"],
    updateTime: "2026-09-27",
    status: "更新至 24 集",
    views: 6180,
    featured: true,
  },
  {
    id: "t2",
    title: "迷雾之城",
    type: "电视剧",
    region: "中国大陆",
    year: 2023,
    score: 9.0,
    cover:
      "https://readdy.ai/api/search-image?query=dark%20suspense%20tv%20series%20poster%20of%20a%20foggy%20abandoned%20industrial%20town%20at%20night%2C%20single%20figure%20under%20a%20streetlamp%2C%20teal%20grey%20mist%20and%20muted%20crimson%20accents%2C%20eerie%20mysterious%20atmosphere%2C%20cinematic%20noir%20poster&width=600&height=900&seq=cherry-tv-02&orientation=portrait",
    description:
      "一座终年被浓雾笼罩的小城，接连发生的失踪案将一位女记者拖入深不见底的秘密之中。",
    director: "韩松",
    actors: ["周雨桐", "陈默", "吴启"],
    tags: ["悬疑", "犯罪", "刑侦", "烧脑"],
    updateTime: "2026-09-25",
    status: "全 32 集",
    views: 7350,
  },
  {
    id: "t3",
    title: "山河故人梦",
    type: "电视剧",
    region: "中国大陆",
    year: 2022,
    score: 8.3,
    cover:
      "https://readdy.ai/api/search-image?query=epic%20historical%20chinese%20drama%20poster%20of%20misty%20mountains%20and%20a%20lone%20horse%20rider%2C%20traditional%20robes%20flowing%20in%20wind%2C%20ink%20wash%20landscape%20texture%2C%20deep%20crimson%20and%20gold%20accent%2C%20vast%20melancholic%20atmosphere%2C%20cinematic&width=600&height=900&seq=cherry-tv-03&orientation=portrait",
    description:
      "乱世之中，一个家族三代人的命运随山河沉浮，家国大义与儿女情长交织成一曲苍凉长歌。",
    director: "柳云生",
    actors: ["赵怀山", "林清", "章远"],
    tags: ["古装", "历史", "家族", "史诗"],
    updateTime: "2026-09-23",
    status: "全 46 集",
    views: 5540,
  },
  {
    id: "t4",
    title: "医心仁术",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    score: 8.1,
    cover:
      "https://readdy.ai/api/search-image?query=medical%20drama%20tv%20series%20poster%20of%20a%20dedicated%20doctor%20in%20a%20bright%20hospital%20corridor%2C%20soft%20clinical%20lighting%2C%20clean%20muted%20teal%20and%20warm%20white%20tones%2C%20calm%20professional%20mood%2C%20cinematic%20ensemble&width=600&height=900&seq=cherry-tv-04&orientation=portrait",
    description:
      "急诊科的一群医护人员，在生死时速中守护生命，也在一次次抉择里找寻医者的初心。",
    director: "郑安",
    actors: ["罗正", "苏漫", "高毅"],
    tags: ["医疗", "职场", "剧情", "人性"],
    updateTime: "2026-09-21",
    status: "更新至 18 集",
    views: 4260,
  },
  {
    id: "t5",
    title: "长夜将明",
    type: "电视剧",
    region: "英国",
    year: 2024,
    score: 8.8,
    cover:
      "https://readdy.ai/api/search-image?query=british%20period%20drama%20poster%20of%20a%20lonely%20woman%20in%20a%20vintage%20coat%20standing%20on%20a%20rainy%20cobblestone%20street%2C%20gas%20lamps%20glowing%2C%20muted%20olive%20and%20amber%20tones%2C%20melancholic%20elegant%20mood%2C%20cinematic%20film%20poster&width=600&height=900&seq=cherry-tv-05&orientation=portrait",
    description:
      "战后的伦敦百废待兴，一位沉默的护士在救助他人的过程中，慢慢拼凑起被战争击碎的人生。",
    director: "Emily Hart",
    actors: ["Olivia Blake", "James Rowe", "Sophie Lane"],
    tags: ["剧情", "年代", "战争", "人性"],
    updateTime: "2026-09-19",
    status: "全 8 集",
    views: 3120,
  },
  {
    id: "t6",
    title: "璀璨星辰",
    type: "电视剧",
    region: "韩国",
    year: 2025,
    score: 7.8,
    cover:
      "https://readdy.ai/api/search-image?query=glossy%20romance%20korean%20drama%20poster%20of%20an%20idol%20singer%20under%20stage%20spotlights%2C%20neon%20bokeh%20and%20star%20particles%2C%20soft%20pink%20gold%20and%20deep%20navy%20tones%2C%20dreamy%20glamorous%20atmosphere%2C%20cinematic%20poster%20art&width=600&height=900&seq=cherry-tv-06&orientation=portrait",
    description:
      "曾经万众瞩目的偶像因丑闻跌落谷底，在最灰暗的时刻，一位普通的舞台灯光师让他重新看见星光。",
    director: "车在赫",
    actors: ["李泰民", "朴智媛", "郑多恩"],
    tags: ["爱情", "音乐", "青春", "偶像"],
    updateTime: "2026-09-17",
    status: "更新至 14 集",
    views: 3890,
  },
  {
    id: "v1",
    title: "星光大擂台",
    type: "综艺",
    region: "中国大陆",
    year: 2025,
    score: 8.5,
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20music%20talent%20show%20poster%20of%20a%20bright%20concert%20stage%20with%20colorful%20spotlights%20and%20confetti%2C%20energetic%20silhouettes%20of%20performers%2C%20electric%20crimson%20and%20gold%20tones%2C%20festive%20celebratory%20energy%2C%20cinematic%20poster&width=600&height=900&seq=cherry-vr-01&orientation=portrait",
    description:
      "来自全国的舞台新星同台竞技，用歌声与舞蹈争夺年度总冠军，每一期都是一场视听盛宴。",
    director: "综艺制作中心",
    actors: ["何明", "李婉", "赵一鸣"],
    tags: ["音乐", "竞技", "真人秀", "舞台"],
    updateTime: "2026-09-29",
    status: "每周六更新",
    views: 6720,
    featured: true,
  },
  {
    id: "v2",
    title: "舌尖寻味记",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    score: 9.2,
    cover:
      "https://readdy.ai/api/search-image?query=warm%20food%20documentary%20poster%20of%20a%20rustic%20wooden%20table%20filled%20with%20steaming%20regional%20dishes%2C%20soft%20golden%20kitchen%20light%2C%20rich%20amber%20and%20earthy%20brown%20tones%2C%20cozy%20appetizing%20atmosphere%2C%20cinematic%20top%20view&width=600&height=900&seq=cherry-vr-02&orientation=portrait",
    description:
      "跟随镜头走遍大江南北，寻访街头巷尾的地道风味，讲述食物背后最动人的人间烟火。",
    director: "纪录片工作室",
    actors: ["旁白：周涛"],
    tags: ["美食", "纪实", "人文", "治愈"],
    updateTime: "2026-09-28",
    status: "全 12 期",
    views: 8210,
  },
  {
    id: "v3",
    title: "奔跑吧少年",
    type: "综艺",
    region: "中国大陆",
    year: 2025,
    score: 7.6,
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20outdoor%20reality%20show%20poster%20of%20young%20people%20running%20through%20a%20sunny%20city%20park%2C%20dynamic%20motion%20blur%2C%20bright%20orange%20and%20fresh%20green%20accents%2C%20playful%20joyful%20mood%2C%20cinematic%20sports%20poster&width=600&height=900&seq=cherry-vr-03&orientation=portrait",
    description:
      "一群热血少年在城市与自然之间展开体能与智慧的对决，笑点与燃点齐飞的户外竞技秀。",
    director: "综艺制作中心",
    actors: ["陈昊", "林可", "吴宇", "何洁"],
    tags: ["竞技", "户外", "真人秀", "欢乐"],
    updateTime: "2026-09-26",
    status: "每周五更新",
    views: 4930,
  },
  {
    id: "v4",
    title: "声临其境音乐季",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    score: 8.9,
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20music%20competition%20poster%20of%20a%20singer%20at%20a%20vintage%20microphone%20on%20a%20dark%20stage%2C%20warm%20gold%20spotlight%20beam%2C%20rich%20amber%20and%20deep%20crimson%20palette%2C%20intimate%20emotional%20mood%2C%20cinematic%20studio%20poster&width=600&height=900&seq=cherry-vr-04&orientation=portrait",
    description:
      "顶级歌手以声音重新演绎经典金曲，在纯粹的舞台上用歌声讲述那些被岁月珍藏的故事。",
    director: "音乐节目中心",
    actors: ["冯坤", "李欣", "郑源"],
    tags: ["音乐", "竞演", "金曲", "舞台"],
    updateTime: "2026-09-24",
    status: "全 10 期",
    views: 6010,
  },
  {
    id: "v5",
    title: "奇幻旅程",
    type: "综艺",
    region: "中国大陆",
    year: 2024,
    score: 8.0,
    cover:
      "https://readdy.ai/api/search-image?query=travel%20adventure%20variety%20show%20poster%20of%20backpackers%20on%20a%20mountain%20ridge%20at%20sunrise%2C%20golden%20clouds%20and%20mist%2C%20warm%20amber%20and%20mountain%20blue%20tones%2C%20free%20adventurous%20mood%2C%20cinematic%20panoramic%20poster&width=600&height=900&seq=cherry-vr-05&orientation=portrait",
    description:
      "六位嘉宾离家远行，深入鲜有人至的秘境，在旅途的意外与惊喜中重新认识世界与自己。",
    director: "旅行节目组",
    actors: ["高远", "苏晴", "罗宇", "林一"],
    tags: ["旅行", "户外", "真人秀", "人文"],
    updateTime: "2026-09-22",
    status: "全 13 期",
    views: 3540,
  },
  {
    id: "v6",
    title: "欢乐喜剧营",
    type: "综艺",
    region: "中国大陆",
    year: 2023,
    score: 7.9,
    cover:
      "https://readdy.ai/api/search-image?query=funny%20comedy%20show%20poster%20of%20a%20warm%20colorful%20stage%20with%20comedians%20laughing%20under%20soft%20pink%20and%20gold%20lights%2C%20playful%20props%20and%20confetti%2C%20cheerful%20upbeat%20mood%2C%20cinematic%20variety%20poster&width=600&height=900&seq=cherry-vr-06&orientation=portrait",
    description:
      "全国顶尖喜剧人齐聚一堂，用一个个笑中带泪的原创作品，为观众送去一整季的欢乐。",
    director: "喜剧节目中心",
    actors: ["马腾", "刘洋洋", "何欢", "赵一"],
    tags: ["喜剧", "竞演", "欢乐", "舞台"],
    updateTime: "2026-09-20",
    status: "全 12 期",
    views: 2870,
  },
];